<template>
  <div class="filter-infos" v-if="filterGroups && filterGroups.length > 0">
    <div
      v-for="filterGroup in filterGroups"
      :key="filterGroup.key"
      class="filter-group">
      <div class="filter-group-label">
        <span class="label-text">{{ filterGroup.label }}:</span>
      </div>

      <div class="filter-tags">
        <div  v-for="tag in filterGroup.tags"
              :key="tag.id"
              class="filter-tag">
          <span class="tag-text">{{ tag.label }}</span>
          <component  v-if="tag.icon"
                      :is="tag.icon"
                      :size="12"
                      class="tag-icon" />
          <X  :size="8"
              class="tag-remove"
              @click="handleRemoveTag(filterGroup.key, tag)" />
        </div>
      </div>

      <div v-if="filterGroup.divider" class="filter-divider"></div>
    </div>
  </div>
</template>

<script>
import { X, Circle } from 'lucide-vue-next';

export default {
  name: 'FilterInfos',

  components: {
    X,
    Circle
  },

  props: {
    filterGroups: {
      type: Array,
      required: true
    }
  },

  emits: ['remove-tag'],

  methods: {
    handleRemoveTag(groupKey, tag) {
      this.$emit('remove-tag', { groupKey, tag });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-infos {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px;
  border: 1px solid var(--bs-border-color);
  border-radius: var(--radius-md);
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 24px;
}

.filter-group-label {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 50px;
}

.label-text {
  font-size: 0.6875rem;
  color: var(--bs-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
}

.filter-tag {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: var(--bs-tertiary-bg);
  border-radius: var(--radius-sm);
  border: 1px solid var(--bs-border-color);
  transition: all 0.15s;

  &:hover {
    background: var(--bs-secondary-bg);
  }
}

.tag-text {
  font-size: 0.6875rem;
  font-weight: 600;
  color: var(--bs-body-color);
}

.tag-icon {
  flex-shrink: 0;
  color: var(--bs-secondary-color);
}

.tag-remove {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--bs-body-color);
  transition: color 0.15s;

  &:hover {
    color: var(--bs-danger);
  }
}

.filter-divider {
  width: 1px;
  height: 20px;
  background: var(--bs-border-color);
  margin: 0 8px;
}
</style>
